
import React from 'react';
import { SectionTitle, ScrollNavigation } from './Components';

export const FAQsPage: React.FC = () => {
  const faqs = [
    {
      q: "Who are the doctors on ROVITA?",
      a: "All our doctors are board-certified and licensed in the U.S., U.K., or EU countries. They are carefully vetted and experienced in both in-person and telemedicine care."
    },
    {
      q: "What medical services do you offer?",
      a: "We offer general consultations, specialist appointments, second opinions, and follow-ups. We also provide e-prescriptions where allowed by local laws."
    },
    {
      q: "Is my information safe and private?",
      a: "Yes. We comply with strict data protection laws like HIPAA (USA) and GDPR (EU). All consultations and medical records are encrypted."
    },
    {
      q: "Can I get a consultation in my language?",
      a: "Yes. We offer multilingual support. Many of our doctors speak multiple languages, and we have language-specific options during booking."
    },
    {
      q: "What if I need emergency care?",
      a: "ROVITA is not for emergencies. If you’re experiencing life-threatening symptoms, please go to the nearest hospital or call local emergency services."
    },
    {
      q: "How do I book an appointment?",
      a: "Just click on “Start Free Consultation,” choose your doctor or service, select a time, and pay securely. You’ll receive a link for the virtual appointment."
    }
  ];

  return (
    <div className="py-16 max-w-7xl mx-auto px-4 animate-in fade-in duration-500">
      <div className="text-center mb-16">
        <SectionTitle centered title="Frequently Asked Questions" subtitle="Everything you need to know about our service." />
      </div>
      
      <div className="grid md:grid-cols-2 gap-6 md:gap-8">
        {faqs.map((f, i) => (
            <div key={i} className="bg-white p-8 md:p-10 rounded-[2.5rem] shadow-sm border border-slate-100 hover:shadow-lg transition-all duration-300 group">
                <div className="flex gap-4 items-start mb-4">
                    <span className="w-10 h-10 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center font-black text-sm shrink-0 group-hover:bg-indigo-600 group-hover:text-white transition-colors">
                        Q{i+1}
                    </span>
                    <h4 className="font-black text-slate-900 text-xl leading-tight pt-1.5">{f.q}</h4>
                </div>
                <p className="text-slate-700 font-medium leading-relaxed pl-14 text-lg">
                    {f.a}
                </p>
            </div>
        ))}
      </div>
      <ScrollNavigation nextId="footer" prevId="hero" isLast />
    </div>
  );
};
